<template>
  <div class="d-flex">
    <span style="font-size: 14px;">{{ number }}. </span>
    <span style="font-size: 15px;" v-html="item"></span>
  </div>
</template>

<script>
  export default {
    name: 'PolicyItem',

    props: {
      number: { type: Number },
      item: { type: String }
    }
  }
</script>

<style lang="scss" scoped>

</style>